import React from 'react'
import PropTypes from 'prop-types'
import warningSvgPath from '../../../assets/icons/warning'
import Svg from '../Svg'

const AlertSymbol = props => (
  <Svg
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    svgPath={warningSvgPath}
    color={props.color}
  />
)

AlertSymbol.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

AlertSymbol.defaultProps = {
  width: 40,
  height: 40,
  color: '#ff3b3c',
}

export default AlertSymbol
